export default {
    SocialLogin: {
        "Wellcome to": "Welcome to",
        "Unfortunately": "Unfortunately",
        "this account has been banned": "this account has been banned",
        "Back to login": "Back to login",
        "Continue with": "Continue with",
        "By creating account you accept terms of use": "By creating account you accept terms of use",
    },
    RegistrationFirebase: {
        "Registration": "Registration",
        "Email": "Email",
        "Password": "Password",
        "Confirm password": "Confirm password",
        "CONTINUE": "CONTINUE",
        "Already have an account?": "Already have an account?",
    },
    SocialAuthStepTwo: {
        "Add photo": "Add photo",
        "Let’s be friends.": "Let’s be friends.",
        "What we can call you?": "What we can call you?",
        "Your first name": "Your first name",
        "Your last name": "Your last name",
        "Your last name(optional)": "Your last name (optional)",
        "Date of birth": "Date of birth",
        "What is your gender?": "What is your gender?",
        "Man": "Man",
        "Woman": "Woman",
        "Other": "Other",
        "NEXT": "NEXT",
    },
    SocialAuthStepThree: {
        "Tell us more about yourself": "Tell us more about yourself",
        "Your location": "Your location",
        "Your languages": "Your languages",
        "Start typing to add": "Start typing to add",
        "Field of work (optional)": "Field of work (optional)",
        "Choose one from the list": "Choose one from the list",
        "Add your social account or messenger (optional)": "Add your social account or messenger (optional)",
        "Choose your preferred messenger": "Choose your preferred messenger",
        "Contact details": "Contact details",
        "A few words about yourself": "A few words about yourself",
        "A few words about yourself(optional)": "A few words about yourself (optional)",
        "Bio": "Bio", // Biography
        "Bio(optional)": "Bio (optional)", // Biography
        "Your interests": "Your interests",
        "Photos (optional)": "Photos (optional)",
        "Add photo": "Add photo",
        "SAVE": "SAVE",
    },
    MainSlot: {
        "Full name": "Full name",
        "Reserve": "Reserve",
        "Events": "Events",
        "Reserve a spot": "Reserve a spot",
        "My Calendar": "My Calendar",
        "Friends": "Friends",
        "Invite a friend": "Invite a friend",
        "My profile": "My profile",
        "Edit profile": "Edit profile",
        "Deactivate account": "Deactivate account",
        "Log out": "Log out",
        "Who we are?": "Who we are?",
        "Terms and Conditions": "Terms and Conditions",
        "Quick Privacy Settings": "Quick Privacy Settings",
        "Help Center": "Help Center",
        "Are you sure you want to log out?": "Are you sure you want to log out?",
        "Event will start in": "Event will start in",
        "To event page": "To event page",
        "Meeting Error": "Meeting Error",
        "Reserve a seat": "Reserve a seat",
        "Congratulations!": "Congratulations!",
        "You have reserved a seat at a new event. <br> You can cancel your reservation at any time.": "You have reserved a seat at a new event. <br> You can cancel your reservation at any time.",
        "You have reserved a seat at a new event.": "You have reserved a seat at a new event.",
        "You can cancel your reservation at any time.": "You can cancel your reservation at any time.",
        "Cancel reservation": "Cancel reservation",
        "Your reservation was successfully canceled.": "Your reservation was successfully canceled.",
        "OOPS... Something went wrong...": "OOPS... Something went wrong...",
        "Are you sure you want to cancel your reservation for": "Are you sure you want to cancel your reservation for",
        "on": "on", // [title] on [date]
    },
    Events: {
        "Events": "Events",
        "Filter": "Filter",
        "users per conversation": "users per conversation",
        "You’ve already reserved online seat": "You’ve already reserved online seat",
        "You’ve already reserved offline seat": "You’ve already reserved offline seat",
        "You’ve already reserved a seat": "You’ve already reserved a seat",
        "Locations:": "Locations:",
        "Event type:": "Event type:",
        "Any type": "Any type",
        "Only online events": "Only online events",
        "Only offline events": "Only offline events",
        "Tags:": "Tags:",
        "Start typing to add": "Start typing to add",
        "Sorry, nothing here yet.": "Sorry, nothing here yet.",
        "Sorry, but nothing found. Try something else.": "Sorry, but nothing found. Try something else.",

    },
    ContactPersonWidget: {
        "Contact person": "Contact person",
    },
    ConversationStartersWidget: {
        "Conversation starters": "Conversation starters",
    },
    DresscodeWidget: {
        "Dress code": "Dress code",
    },
    EventInfoWidget: {
        "Offline event": "Offline event",
        "Online event": "Online event",
        "See on map": "See on map",
        "Host:": "Host:",
        "Age limit:": "Age limit:",
        "min for conversation": "min for conversation",
        "users per conversation": "users per conversation",
    },
    Calendar: {
        "My calendar": "My calendar",
        "Future events": "Future events",
        "Past events": "Past events",
        "You don’t have any future events yet.": "You don’t have any future events yet.",
        "You don’t have any past events yet.": "You don’t have any past events yet.",
        "users per conversation": "users per conversation",
        "Online event": "Online event",
        "Offline event": "Offline event",
        "friends": "friends",
        "No matches": "No matches",
    },
    Friends: {
        "Filter": "Filter",
        "Search": "Search",
        "Sorry, you don’t have any friends yet. In order to find new friends visit the event.": "Sorry, you don’t have any friends yet. In order to find new friends visit the event.",
        "FIND EVENT": "FIND EVENT",
        "You’ve met at": "You’ve met at",
        "events attended": "events attended",
        "Select locations:": "Select locations:",
        "Start typing to add": "Start typing to add",
        "Sorry, but nothing found. Try something else.": "Sorry, but nothing found. Try something else.",
        "Search results": "Search results",
        "Friends": "Friends",
        "Friendzone": "Friendzone",
        "Showing {from} to {to} of {count} friends|{count} friends|One friend":"Showing {from} to {to} of {count} friends|{count} friends|One friend"
    },
    Profile: {
        "events attended": "events attended",
        "event attended": "event attended",
        "View less": "View less",
        "View all": "View all",
        "Photos:": "Photos:",
        "Add photo": "Add photo",
        "Delete": "Delete",
    },
    EditProfile: {
        "Edit profile": "Edit profile",
        "User Info:": "User Info:",
        "First Name": "First Name",
        "Last Name": "Last Name",
        "Last Name(optional)": "Last Name (optional)",
        "Date of birth": "Date of birth",
        "Your location:": "Your location:",
        "Start typing to add": "Start typing to add",
        "A few words about yourself": "A few words about yourself",
        "A few words about yourself(optional)": "A few words about yourself (optional)",
        "Choose one from the list": "Choose one from the list",
        "Add your social account or messenger:": "Add your social account or messenger:",
        "Choose your preferred messenger": "Choose your preferred messenger",
        "Contact details": "Contact details",
        "Your interests:": "Your interests:",
    },
    EventDetails: {},
    StartedMeeting: {
        "left": "left", // seconds left
        "Me": "Me",
        "Rooms": "Rooms",
        "Room": "Room",
        "Unable to join meeting": "Unable to join meeting",
        "There was an issue joining that meeting. Check your connectivity and try again.": "There was an issue joining that meeting. Check your connectivity and try again.",
        "Choose a reason:": "Choose a reason:",
        "The complaint was successfully sent.": "The complaint was successfully sent.",
        "You have already submitted a complaint about this user.": "You have already submitted a complaint about this user.",
        "hours": "hours",
        "hour": "hour",
        "mins": "mins", // short minutes
        "sec": "sec", // short seconds
        "Complain": "Complain",
    },
    MeetingPage: {
        "No voice. Please, check your mic.": "No voice. Please, check your mic.",
        "Settings": "Settings",
        "No video. Please, check your camera.": "No video. Please, check your camera.",
        "Event will start in": "Event will start in",
        "In the meantime, you can check your webcam and microphone": "In the meantime, you can check your webcam and microphone",
        "hour": "hour",
        "mins": "mins", // short minutes
        "sec": "sec", // short seconds
    },
    EventPastDetails: {
        "My calendar": "My calendar",
        "Past events": "Past events",
        "View less": "View less",
        "View all": "View all",
        "friends": "friends",
        "events attended": "events attended",
        "View profile": "View profile",
    },
    FriendProfile: {
        "events attended": "events attended",
        "Report user": "Report user",
        "View less": "View less",
        "View all": "View all",
        "You matched with": "You matched with",
        "at:": "at:",
        "users per conversation": "users per conversation",
        "friends": "friends",
        "Reserve a seat": "Reserve a seat",
        "You’ve already reserved a seat": "You’ve already reserved a seat",
        "'s future events:": "'s future events:",
        "Photos:": "Photos:",
    },
    MeetingResultsYes: {
        "Event ended": "Event ended",
        "Thanks for joinging us today!": "Thanks for joinging us today!",
        "friends": "friends",
        "events attended": "events attended",
        "Find more events": "Find more events",
    },
    PageNotFound: {
        "There’s nothing here...": "There’s nothing here...",
        "...maybe the page you're looking for is not found or never existed.": "...maybe the page you're looking for is not found or never existed.",
        "Log in": "Log in",
        "Back to home": "Back to home",
    },
    modals: {
        "Location on map": "Location on map",
        "Delete": "Delete",
        "Are you sure you want to delete this picture?": "Are you sure you want to delete this picture?",
        "Are you sure you want to delete this background?": "Are you sure you want to delete this background?",
        "Report user": "Report user",
        "Reason of your report": "Reason of your report",
    },
    buttons: {
        "Cancel": "Cancel",
        "Confirm": "Confirm",
        "Cancel reservation": "Cancel reservation",
        "OK": "OK",
        "Close": "Close",
        "No": "No",
        "Yes": "Yes",
        "Reserve online seat": "Reserve online seat",
        "Reserve a seat": "Reserve a seat",
        "Reserve offline seat": "Reserve offline seat",
        "CLEAR ALL": "CLEAR ALL",
        "APPLY": "APPLY",
        "Clear all": "Clear all",
        "Apply": "Apply",
        "CANCEL": "CANCEL",
        "SAVE CHANGES": "SAVE CHANGES",
        "SEND COMPLAIN": "SEND COMPLAIN",
        "Send report": "Send report",
    },
    validation: {
        "Passwords do not match. Please, try again.": "Passwords do not match. Please, try again.",
        "Invalid Email Format.": "Invalid Email Format.",
        "Password length must be between 8 and 20 characters.": "Password length must be between 8 and 20 characters.",
        "Validation error": "Validation error",
        "Something went wrong...": "Something went wrong...",
        "Please, add a picture.": "Please, add a picture.",
        "Please, fill out all the required fields.": "Please, fill out all the required fields.",
        "Incorrect Value": "Incorrect Value",
        "Sorry, you’ve reached the limit. You can only add 10 pictures.": "Sorry, you’ve reached the limit. You can only add 10 pictures.",
        "Auth error.": "Auth error.",
        "OOPS... Something went wrong...": "OOPS... Something went wrong...",
        "The First Name field cannot be empty": "The First Name field cannot be empty",
        "The Last Name field cannot be empty": "The Last Name field cannot be empty",
        "Please, select reason.": "Please, select reason.",
        "User is not exists.": "User is not exists.",
    },
    public:{
        "Events":"Events",
        "Posts":"Posts",
        "It’s a private group.":"It’s a private group.",
        "seats":"seats"
    }
}
